/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bpgFooter[_ngcontent-%COMP%]{left:0;bottom:0;width:100%;background-color:#fff;border-top:1px solid #ededed;color:#000;padding:20px 60px}p[_ngcontent-%COMP%]{margin:0}@media only screen and (max-width:767px){.bpgFooter[_ngcontent-%COMP%]{flex-direction:column;align-items:center;padding:20px 40px}}.footer-container[_ngcontent-%COMP%]{padding:0 15px}\n/*# sourceMappingURL=bpg-footer.component.css.map*/"];
export { styles as styles };
